import React from 'react';
import './App.css';
import Chat from './components/Chat';

const App: React.FC = () => {
  return (
    <div className="App">
      <header className="App-header">
        <h1>EduBot - Smart Study Advisor 2.0 🤖</h1>
        <p>Choose a suitable profession based on your preferences</p>
      </header>
      <main>
        <Chat />
      </main>
    </div>
  );
};

export default App;
